<template>
  <h1 class="uk-text-center uk-margin-large-top">管理者ログイン</h1>
  <div class="uk-text-center uk-margin-large-top">
    <form @submit.prevent="login">
      <div class="uk-margin">
        <div class="uk-inline">
          <span class="uk-form-icon" uk-icon="icon: mail"></span>
          <input class="uk-input" type="email" v-model="email" />
        </div>
      </div>

      <div class="uk-margin">
        <div class="uk-inline">
          <span class="uk-form-icon" uk-icon="icon: lock"></span>
          <input class="uk-input" type="password" v-model="password" />
        </div>
      </div>
      <button class="uk-button uk-button-default uk-margin-auto" type="submit">
        Submit
      </button>
    </form>
  </div>
</template>

<script>
import firebase from 'firebase'
export default {
  data() {
    return {
      email: '',
      password: '',
      user: null,
      sending: false,
    }
  },
  methods: {
    login() {
      firebase
        .auth()
        .signInWithEmailAndPassword(this.email, this.password)
        .catch(function (error) {
          // Handle Errors here.
          var errorCode = error.code
          var errorMessage = error.message
          console.log(errorCode)
          console.log(errorMessage)
        })
    },
  },
}
</script>

<style>
</style>